"use client";

import { CheckPermissionsInput } from "@zapier/bff";
import { useCallback, useMemo, useState } from "react";
import { trpc } from "../trpc";

interface UseCheckAssetPermissionsInput {
  assetId?: string;
  assetType: CheckPermissionsInput["assetType"];
  permissionLevels: string[];
}

export function useCheckPermissions(input: UseCheckAssetPermissionsInput) {
  const [shouldFetch, setShouldFetch] = useState(false);

  const queryInput = useMemo<CheckPermissionsInput>(() => {
    return {
      assetIds: input.assetId ? [input.assetId] : [],
      assetType: input.assetType,
      permissionLevels: input.permissionLevels,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we do want shouldFetch to be a dependencys
  }, [input, shouldFetch]);

  const { data, isLoading, isFetched } =
    trpc.permission.checkPermissions.useQuery(queryInput, {
      enabled: shouldFetch && queryInput.assetIds.length > 0,
      select: (data) => {
        return data?.results[0].permissionLevels as Record<
          string,
          boolean | undefined
        >;
      },
    });

  const checkPermissions = useCallback(() => {
    setShouldFetch(true);
  }, []);

  return {
    checkPermissions,
    isLoading,
    isFetched,
    // The upstream type is incorrect; this should return `boolean | undefined`
    permissions: data,
  };
}
